import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FlecheDroiteMediumPictoProps extends pictoProps {
}

export interface FlecheDroiteMediumPictoState extends pictoState {
}

export class FlecheDroiteMediumPicto extends Picto<FlecheDroiteMediumPictoProps,FlecheDroiteMediumPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.flecheDroiteMediumPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FlecheDroiteMediumPicto);
